export default __webpack_public_path__ + "img/404.3435d362.svg";